export default __webpack_public_path__ + "static/media/review_regular_user.5adb7418.svg";